import Iodine from '@caneara/iodine';

const iodine = new Iodine();

iodine.rule('every', function (value, param) {

    if (!Array.isArray(value)) {
        value = [];
    }

    return value.every(item => param.includes(item));
});

iodine.setErrorMessage('every', "[FIELD] must be equal to '[PARAM]'");

export default {

    setup: false,
    data: {},
    fields: {},

    isSetup() {
        return this.setup;
    },

    isValid() {
        return Object.keys(this.fields).every(field => this.isFieldValid(field));
    },

    isFieldValid(field) {
        return this.fields[field].valid;
    },

    validate() {
        Object.keys(this.fields).forEach(field => this.validateField(field));
    },

    validateField(field) {

        const results = iodine.assert(this.data[field], this.fields[field].rules);

        this.fields[field].valid = results.valid;
        this.fields[field].rule = results.rule;
        this.fields[field].error = results.error;
    },

    addField(field, rules) {

        this.setup = true;

        this.data[field] = null;

        if (typeof rules === 'function') {
            rules = rules();
        }

        this.fields[field] = {
            valid: false,
            rule: '',
            error: '',
            rules: rules,
        };
    },

    updateData(field, value) {
        this.data[field] = value;
    },

    reset() {
        this.setup = false;
        this.data = {};
        this.fields = {};
    },

};
